export default "__VITE_ASSET__C$ZGpIDg__"